import { FC, useEffect } from "react";

import { State } from "../../../redux/slices";
import { useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";

import LinkUsersToLocation from "../../grainWise/edit/LinkUsersToLocation";
import { logoutGrainTrackerE } from "../../../redux/slices/grainTracker/grainTrackerEdition";
import MenuEditLocationPreset from "./MenuEditLocation";

const LinkUsersToLocations: FC<any> = () => {
  const {
    selectedLocation,
    isCreatingWithGrainTracker,
    locationGrainTrackerValues,
  } = useSelector((state: State) => state.GrainWiseEditionReducer);

  const navigate = useNavigate();

  window.onunload = function (e) {
    e.preventDefault();
  };

  useEffect(() => {
    if (!selectedLocation.values.id) {
      navigate("/locations");
    }
  }, []);

  return (
    <div className="create-sites-container">
      <MenuEditLocationPreset />
      {
        <LinkUsersToLocation
          isCreatingWithGrainTracker={isCreatingWithGrainTracker}
          locationGrainTrackerValues={locationGrainTrackerValues}
          logOutGrainTracker={logoutGrainTrackerE}
        />
      }
    </div>
  );
};

export default LinkUsersToLocations;
